/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DelegationsDeleted,
    DelegationsDeletedFromJSON,
    DelegationsDeletedFromJSONTyped,
    DelegationsDeletedToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationsDeletedResponse
 */
export interface DelegationsDeletedResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof DelegationsDeletedResponse
     */
    msg: string;
    /**
     * 
     * @type {DelegationsDeleted}
     * @memberof DelegationsDeletedResponse
     */
    entry: DelegationsDeleted;
}

export function DelegationsDeletedResponseFromJSON(json: any): DelegationsDeletedResponse {
    return DelegationsDeletedResponseFromJSONTyped(json, false);
}

export function DelegationsDeletedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationsDeletedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': DelegationsDeletedFromJSON(json['entry']),
    };
}

export function DelegationsDeletedResponseToJSON(value?: DelegationsDeletedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': DelegationsDeletedToJSON(value.entry),
    };
}


